export default __webpack_public_path__ + "static/media/pa.8667769d.svg";